import {SearchResultItem} from '@/model/api/search';
import TransactionFinder from '@/model/TransactionFinder';

export default class ApiTransactionFinder implements TransactionFinder {
    public search(searchQuery: string): Promise<SearchResultItem[]> {
        const queryParameters = new URLSearchParams({
            query: searchQuery,
        });

        return fetch(`/api/cadastre/transactions?${queryParameters.toString()}`)
            .then(response => response.json())
            .then(body => this.toResultItemArray(body.result));
    }

    private toResultItemArray(result: ResultItem[]): SearchResultItem[] {
        return result.map(item => ApiTransactionFinder.toSearchResultItem(item));
    }

    private static toSearchResultItem(item: ResultItem): SearchResultItem {
        return {id: item.id, name: item.id};
    }
}

interface ResultItem {
    id: string;
}
